import { createAction, props } from '@ngrx/store';
import { IRequestor } from 'src/app/shared/models/requestor/IRequestor';
import { ApiResponseSimple } from 'src/app/shared/models/api-response-simple/ApiResponseSimple';

export const RequestAccessActionTypes = {
  CAPTCHA: '[Request Access Page] Captcha',
  REQUEST: '[Request Access Page] Request',
  REQUEST_ERROR: '[LogRequest Accessin Page] Request Access error',
  REQUEST_SUCCESS: '[Request Access Page] Request Access success'
};

export const RequestAccessCaptchaAction = createAction(
  RequestAccessActionTypes.CAPTCHA,
  props<{}>()
);

export const RequestAccessAction = createAction(
  RequestAccessActionTypes.REQUEST,
  props<{ requestor: IRequestor }>()
);

export const RequestAccessSuccessAction = createAction(
  RequestAccessActionTypes.REQUEST_SUCCESS,
  props<{ response: ApiResponseSimple }>()
);

export const RequestAccessErrorAction = createAction(
  RequestAccessActionTypes.REQUEST_ERROR,
  props<{}>()
);
